import React from 'react'
import { connect } from 'react-redux'
import { Page, NewsPageContent } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import PropTypes from 'prop-types'
import {
  Contact,
  ConsumerRights,
  SecureShopping,
  Help
} from 'src/modules/staticInfo'
import config from 'SRC/config/config.json'

class Static extends React.Component {
  static async getInitialProps({ store, query }) {
    const { title, fileContent, forApp } = query

    if (!title || !fileContent) {
      // This case should ideally be handled by the server,
      // but as a fallback, we can show a 404-like state.
      return {
        title: 'Stranica nije pronađena',
        fileContent: '',
        state: Static.getPageState(store)
      }
    }

    return {
      title,
      fileContent,
      forApp,
      state: Static.getPageState(store)
    }
  }

  static getPageState(store) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = false
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo

      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas

      state.form = currentState.form
    }
    return state
  }

  render() {
    const { title, fileContent, forApp } = this.props

    return (
      <Page>
        <NewsPageContent title={title} showHeadingTitle={!forApp}>
          <div dangerouslySetInnerHTML={{ __html: fileContent }} />
        </NewsPageContent>
      </Page>
    )
  }
}

Static.propTypes = {
  title: PropTypes.string.isRequired,
  fileContent: PropTypes.string,
  forApp: PropTypes.bool
}

export default Static
